<template>
  <div>
    <v-title>Address Detail</v-title>
    <v-card>
      <v-card-text>
        <v-card>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12 md12 lg12>
                <v-autocomplete
                  :items="results"
                  label="Search for physical street Address, not PO Box"
                  :search-input.sync="search"
                  v-model="streetAddress"
                  item-text="formatted_address"
                  item-value="formatted_address"
                  @change="completeAddress"
                  :filter="customFilter"
                  persistent-hint
                  :browser-autocomplete="isGoogleChrome ? 'disabled' :  'off'"
                >
                  <template slot="nodata" slot-scope="data"></template>
                </v-autocomplete>
              </v-flex>
              <v-flex sm6 md6 lg6>
                <v-text-field
                  :disabled="true"
                  label="Street Address"
                  type="text"
                  name="streetAddress"
                  v-validate="'required'"
                  v-model="streetAddress"
                ></v-text-field>
                <span
                  v-show="errors.has('streetAddress')"
                  class="red--text"
                >{{ errors.first('streetAddress') }}</span>
              </v-flex>
              <v-flex sm6 md6 lg6>
                <v-text-field
                  :disabled="true"
                  label="Suburb"
                  type="text"
                  name="suburb"
                  v-validate="'required'"
                  v-model="suburb"
                ></v-text-field>
                <span v-show="errors.has('suburb')" class="red--text">{{ errors.first('suburb') }}</span>
              </v-flex>
              <v-flex sm3 md3 lg3>
                <v-text-field
                  :disabled="true"
                  label="State"
                  name="state"
                  v-model="state"
                  v-validate="'required'"
                ></v-text-field>

                <span v-show="errors.has('state')" class="red--text">{{ errors.first('state') }}</span>
              </v-flex>
              <v-flex sm3 md3 lg3>
                <v-text-field
                  data-cy-post-code
                  :disabled="true"
                  label="Postcode"
                  type="text"
                  name="postCode"
                  v-validate="'required|numeric'"
                  v-model="postCode"
                ></v-text-field>
                <span
                  v-show="errors.has('postCode')"
                  class="red--text"
                >{{ errors.first('postCode') }}</span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn @click="addCustomerAddress" color="primary">Save</v-btn>
            <v-btn @click="$emit('close')" color="light-grey">Close</v-btn>
          </v-card-actions>
        </v-card>

        <message-alert :component="address.message"></message-alert>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { createNamespacedHelpers } from "vuex";
import { HTTP } from "../http-common";
import { mapAddressFields, mapCustomerFields } from "../store/modules/orders";
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapAddressActions,
  mapMutations: mapAddressMutations
} = createNamespacedHelpers(`orders/address`);
const { mapActions: mapCustomerActions } = createNamespacedHelpers(
  `orders/customer`
);

export default {
  props: ["add"],
  computed: {
    ...mapAddressFields([
      "address.addressID",
      "address.postCode",
      "address.state",
      "address.streetAddress",
      "address.suburb",
      "address.customerID",
      "results"
    ]),
    ...mapOrderState(["company", "customer", "address", "isGrenke"]),
    ...mapCustomerFields({
      custid: "customer.customerID",
      addrID: "customer.addressID"
    }),
    ...mapGetters("orders", ["isQantas"]),
    isGoogleChrome () {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    destination () {
      return "direct-debit";
    }
  },
  data () {
    return {
      isDataLoading: false,
      isSaved: false,

      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: null
    };
  },

  mounted () {
    this.$nextTick(() => {
      this.setResults([]);
      if (this.add == "true") {
        this.customerID = this.custid;
      } else {
        if (this.addrID) {
          this.getAddress(this.addrID);
        }
      }
    });
  },
  methods: {
    ...mapAddressActions([
      "resetAddress",
      "getAddress",
      "addAddress",
      "updateAddress",
      "addAddressToCust",
      "updateAddressToCust",
      "searchAddress",
      "completeAddress"
    ]),
    ...mapCustomerActions(["addCustomerToUB"]),
    ...mapAddressMutations(["setResults"]),
    addCustomerAddressToList (address) {
      vm.$emit("closeForList", address);
    },
    addCustomerAddress: function (event) {
      let vm = this;
      vm.isSubmittedSuccessfully = false;
      vm.$validator.validateAll().then(result => {
        if (result) {
          if (vm.add == "true") {
            if (vm.addressID > 0) {
              vm.updateAddress(vm.custid).then(function () {
                vm.$emit("close", vm.addressID);
                return;
              });
            } else {
              vm.addAddress(vm.custid).then(function () {
                vm.$emit("close", vm.addressID);
                return;
              });
            }
          } else {
            if (vm.addrID > 0)
              vm.updateAddressToCust().then(() => {
                if (vm.isQantas) vm.$emit("added", vm.destination);
              });
            else
              vm.addAddressToCust().then(() => {
                if (vm.isQantas) vm.$emit("added", vm.destination);
              });

            return;
          }
        }
      });
    },

    clearDropdown: function (e) {
      let vm = this;
      vm.results = [];
    },
    customFilter (item, queryText, itemText) {
      return true;
      var words = queryText.split(" ").filter(x => x.length > 0);
      var result = false;
      words.forEach(x => {
        result = result || itemText.toLowerCase().includes(x.toLowerCase());
      });
      return result;
    }
  },
  watch: {
    search (val) {
      if (val !== null) {
        if (val.length > 5) this.searchAddress(val);
      }
    }
  }
};
</script>
